import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CrearContenedor = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/contenedores`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearContenedorMutation: mutation.mutate,
    };
}